import httpClient from '@/http-client'

export const get = (Options = {}) => {
    return httpClient
        .get('/api/v1/purchase-request-templates', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
    return httpClient
        .get(`/api/v1/purchase-request-templates/${id}`, Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/v1/purchase-request-templates', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
        .put(`/api/v1/purchase-request-templates/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
        .delete(`/api/v1/purchase-request-templates/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
    return httpClient
        .get('/api/v1/purchase-request-templates/form-view-models', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    get,
    find,
    store,
    update,
    destroy,
    formViewModel
}
